import { ChakraBox, ChakraText, EquipUITheme } from '@equip.health/ui';

interface MessagesMenuFooterProps {
  showingChannelsCount: number;
}

const TOP_LEVEL_ID = 'messages-menu-footer';

const MessagesMenuFooter = ({
  showingChannelsCount,
}: MessagesMenuFooterProps) => {
  const { label } = EquipUITheme.typography;
  return (
    <ChakraBox id={TOP_LEVEL_ID}>
      <ChakraText
        {...label}
        color="neutral.secondary"
        id={`${TOP_LEVEL_ID}__showing-channels-count`}
        padding="4px"
        textAlign="center"
      >
        {`Showing ${showingChannelsCount} Channels`}
      </ChakraText>
    </ChakraBox>
  );
};

export default MessagesMenuFooter;
